import * as React from 'react';
import { ButtonContainer } from './button-components';

type Props = {
  variant?:
    | 'primary'
    | 'secondary'
    | 'text'
    | 'google'
    | 'warning'
    | 'approve'
    | 'other';
  size?: 'small' | 'medium' | 'large';
  width?: string;
  type?: 'button' | 'submit';
  onClick?: (e: any) => void;
  disabled?: boolean;
  children: any;
  backgroundColor?: string;
  color?: string;
};

export default function Button({
  variant = 'primary',
  size = 'medium',
  width,
  type = 'button',
  onClick,
  disabled = false,
  children,
  backgroundColor,
  color,
}: Props) {
  return (
    <ButtonContainer
      variant={variant}
      size={size}
      width={width}
      type={type}
      onClick={onClick}
      disabled={disabled}
      backgroundColor={backgroundColor}
      color={color}>
      {children}
    </ButtonContainer>
  );
}
